import { useRef, useState } from "react";
import { shopRequest } from "./shopRequest";

/** A synchronous guard closes the gap before React renders the disabled controls. */
export function useShopAction() {
  const working = useRef(false);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const run = async (action: () => Promise<unknown>): Promise<boolean> => {
    if (working.current) return false;
    working.current = true; setBusy(true); setError(null);
    try { await shopRequest(() => action()); return true; }
    catch (caught) { setError(caught instanceof Error ? caught.message : "This didn't save. Try again."); return false; }
    finally { working.current = false; setBusy(false); }
  };
  return { busy, error, setError, run };
}
